import { useEffect, useState } from 'react';
import { getYoutubeIdFromUrl } from '@shared/helpers/getYoutubeId.helper';
import { WrapperFullScreen, YoutubeCustom, YoutubeEmbedContainer } from './YoutubeEmbed.style';
interface Props {
  youtubeUrl: string;
}
const YoutubeEmbed = ({
  youtubeUrl
}: Props) => {
  const [shouldShowFullScreen, setShouldShowFullScreen] = useState(false);
  const [iframeElement, setIframeElement] = useState<Element>();
  useEffect(() => {
    handleFullScreen();
  }, [shouldShowFullScreen]);
  const parameters = {
    height: '100%',
    width: '100%',
    playerVars: {
      playsinline: 1,
      modestbranding: 1,
      controls: 1
    }
  };
  const onPlayerReady = player => {
    player.mute();
    player.playVideo();
    setIframeElement(document.getElementsByClassName('iframe-youtube')[0]);
  };
  const handleFullScreen = () => {
    if (shouldShowFullScreen) {
      const requestFullScreen = iframeElement.requestFullscreen;
      if (requestFullScreen) {
        requestFullScreen.bind(iframeElement)();
      }
    } else {
      document.addEventListener('fullscreenchange', () => {
        setShouldShowFullScreen(false);
      }, false);
    }
  };
  return <YoutubeEmbedContainer>
            <WrapperFullScreen onClick={() => setShouldShowFullScreen(true)} style={{
      display: `${shouldShowFullScreen ? 'none' : 'block'}`
    }} />
            <YoutubeCustom iframeClassName="iframe-youtube" videoId={`${getYoutubeIdFromUrl(youtubeUrl)}`} opts={parameters} onReady={e => onPlayerReady(e.target)} onEnd={e => e.target.playVideo()} loading="lazy" />
        </YoutubeEmbedContainer>;
};
export default YoutubeEmbed;